/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const AllegatoTipoAllegatoEnum = {
    Pdf: 'PDF',
    Jpeg: 'JPEG',
    Jpg: 'JPG',
    Png: 'PNG',
    Mpg: 'MPG'
};
/**
 * @export
 */
export const AllegatoTipoDocumentoEnum = {
    AttoCostitutivo: 'ATTO_COSTITUTIVO',
    AttribuzionePartitaIva: 'ATTRIBUZIONE_PARTITA_IVA',
    VerbaleRappLegale: 'VERBALE_RAPP_LEGALE',
    TulpsGioco: 'TULPS_GIOCO',
    LicenzaAams: 'LICENZA_AAMS',
    LicAut: 'LIC_AUT',
    DelegaCasaMadre: 'DELEGA_CASA_MADRE',
    PatenteGuida: 'PATENTE_GUIDA',
    CartaIdentita: 'CARTA_IDENTITA',
    Passaporto: 'PASSAPORTO',
    PatenteFront: 'PATENTE_FRONT',
    PatenteBack: 'PATENTE_BACK',
    CartaIdFront: 'CARTA_ID_FRONT',
    CartaIdBack: 'CARTA_ID_BACK',
    PassaportoFront: 'PASSAPORTO_FRONT',
    PassaportoBack: 'PASSAPORTO_BACK',
    TesseraSanitaria: 'TESSERA_SANITARIA',
    IntEstrattoConto: 'INT_ESTRATTO_CONTO',
    ContrattoUtenzaLocazione: 'CONTRATTO_UTENZA_LOCAZIONE',
    Contratto: 'CONTRATTO',
    ModuloAdv: 'MODULO_ADV',
    ModuloStandard: 'MODULO_STANDARD',
    ModuloSdd: 'MODULO_SDD',
    ModuloAmex: 'MODULO_AMEX',
    ModuloPf: 'MODULO_PF',
    ModuloCn: 'MODULO_CN',
    ModuloWb: 'MODULO_WB',
    ModuloAci: 'MODULO_ACI',
    ModuloRichPosAci: 'MODULO_RICH_POS_ACI',
    ModuloFoglioInformativo: 'MODULO_FOGLIO_INFORMATIVO',
    ModuloPrivacy: 'MODULO_PRIVACY',
    ModuloAbf: 'MODULO_ABF',
    ModuloOpuscoloUe: 'MODULO_OPUSCOLO_UE',
    ModuloAdvSigned: 'MODULO_ADV_SIGNED',
    ModuloStandardSigned: 'MODULO_STANDARD_SIGNED',
    ModuloSddSigned: 'MODULO_SDD_SIGNED',
    ModuloAmexSigned: 'MODULO_AMEX_SIGNED',
    ModuloPfSigned: 'MODULO_PF_SIGNED',
    ModuloCnSigned: 'MODULO_CN_SIGNED',
    ModuloWbSigned: 'MODULO_WB_SIGNED',
    ModuloAciSigned: 'MODULO_ACI_SIGNED',
    ModuloRichPosAciSigned: 'MODULO_RICH_POS_ACI_SIGNED',
    ContrattoDaFirmare: 'CONTRATTO_DA_FIRMARE',
    ContrattoFirmato: 'CONTRATTO_FIRMATO',
    Selfie: 'SELFIE',
    VideoSelfie: 'VIDEO_SELFIE',
    VisuraCamerale: 'VISURA_CAMERALE',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the Allegato interface.
 */
export function instanceOfAllegato(value) {
    let isInstance = true;
    return isInstance;
}
export function AllegatoFromJSON(json) {
    return AllegatoFromJSONTyped(json, false);
}
export function AllegatoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idAllegato': !exists(json, 'idAllegato') ? undefined : json['idAllegato'],
        'tipoAllegato': !exists(json, 'tipoAllegato') ? undefined : json['tipoAllegato'],
        'tipoDocumento': !exists(json, 'tipoDocumento') ? undefined : json['tipoDocumento'],
        'nomeFile': !exists(json, 'nomeFile') ? undefined : json['nomeFile'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}
export function AllegatoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idAllegato': value.idAllegato,
        'tipoAllegato': value.tipoAllegato,
        'tipoDocumento': value.tipoDocumento,
        'nomeFile': value.nomeFile,
        'version': value.version,
    };
}
